import React from "react";
import useClasses from "hooks/useClasses";
import styles from "./CollectableStyle";
import Chip from "@mui/material/Chip";
import Images from "./Images";

const Main = ({ collectable }) => {
  const classes = useClasses(styles);
  return (
    <div>
      <h2 className={classes.sectionTitle}>Recycable Main Data:</h2>
      <div>
        <span className={classes.label}>Name:</span>
        <span className={classes.content}>{collectable.item_name}</span>
      </div>
      <div>
        <span className={classes.label}>Category:</span>
        <span className={classes.content}>{collectable.category}</span>
      </div>
      {collectable.sub_category && (
        <div>
          <span className={classes.label}>Sub Category:</span>
          <span className={classes.content}>{collectable.sub_category}</span>
        </div>
      )}
      {collectable.brand && (
        <div>
          <span className={classes.label}>Brand:</span>
          <span className={classes.content}>{collectable.brand}</span>
        </div>
      )}
      <div>
        <span className={classes.label}>Count:</span>
        <span className={classes.content}>{collectable.item_count}</span>
      </div>
      <div>
        <span className={classes.label}>Condition:</span>
        <span className={classes.content} style={{ display: "inline-flex", gap: "6px", flexWrap: "wrap" }}>
          {collectable.conditions && collectable.conditions.length > 0
            ? collectable.conditions.map((cond, index) => (
                <Chip
                  key={cond.id || index}
                  label={`${cond.name} ${cond.name_ar}`}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              ))
            : collectable.condition && (
                <Chip
                  label={`${collectable.condition} ${collectable.condition_ar || ""}`}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              )}
        </span>
      </div>
      <Images collectable={collectable} />
    </div>
  );
};

export default Main;

